<div class="masonry-grid" #masonryGrid>
    <ngx-masonry [options]="masonryOptions" #masonry>
        <ngxMasonryItem *ngFor="let item of masonryItems" class="masonry-item" [ngClass]="{'half': !item.isExpanded && masonryColumnsEnabled && masonryColumnCount == 2, 'third': masonryColumnsEnabled && masonryColumnCount == 3}">
            <div class="dash-grid--item module drop-shadow bottom" [ngClass]="{'expanded': item.isExpanded, 'expandable': item.isExpandable}">
                <ng-container *ngComponentOutlet="item.component; injector: item.injector"></ng-container>
                <button class="expand-btn focus-element" *ngIf="item.isExpandable" (click)="toggleExpand(item, $event)">
                    <span class="focus--content" tabindex="-1" *ngIf="!item.isExpanded"><svg class="ic"><use xlink:href="#ic-max" href="#ic-max"></use></svg></span>
                    <span class="focus--content" tabindex="-1" *ngIf="item.isExpanded"><svg class="ic"><use xlink:href="#ic-min" href="#ic-min"></use></svg></span>
                </button>
            </div>
        </ngxMasonryItem>
    </ngx-masonry>
</div>
